var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowRight",
    transform: "translate(146.000000, 89.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angle-left.60f083e8",
    transform: "translate(104.000000, 161.000000) scale(-1, 1) translate(-104.000000, -161.000000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7,144 L143.7,8 C153.1,-1.4 168.3,-1.4 177.6,8 L200.2,30.6 C209.6,40 209.6,55.2 200.2,64.5 L103.9,161 L200.3,257.4 C209.7,266.8 209.7,282 200.3,291.3 L177.7,314 C168.3,323.4 153.1,323.4 143.8,314 L7.8,178 C-1.7,168.6 -1.7,153.4 7.7,144 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7,144 L143.7,8 C153.1,-1.4 168.3,-1.4 177.6,8 L200.2,30.6 C209.6,40 209.6,55.2 200.2,64.5 L103.9,161 L200.3,257.4 C209.7,266.8 209.7,282 200.3,291.3 L177.7,314 C168.3,323.4 153.1,323.4 143.8,314 L7.8,178 C-1.7,168.6 -1.7,153.4 7.7,144 Z",
    id: "path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.318dadf35dcde5a5b8b87fe39f3cc992.svg";
export { ForwardRef as ReactComponent };